import type { ReactNode } from 'react';
import { useAuth } from '../../contexts/AuthContext';

interface CanProps {
  /** Permission code, e.g. "users.create". */
  do: string;
  /** Rendered when permission is absent. Defaults to null (hide). */
  fallback?: ReactNode;
  children: ReactNode;
}

export function Can({ do: code, fallback = null, children }: CanProps) {
  const { hasPermission } = useAuth();
  return <>{hasPermission(code) ? children : fallback}</>;
}
